// extracted by mini-css-extract-plugin
export var actionText = "_jt-4";
export var container = "_jt-0";
export var leftSection = "_jt-1";
export var rightSection = "_jt-2";
export var settingsButton = "_jt-6";
export var settingsIcon = "_jt-7";
export var shortcut = "_jt-5";
export var shortcutGroup = "_jt-3";